import React from "react";
import { Container, Row } from "reactstrap";
import { Link } from "react-router-dom";

const Cta = () => {
    return (
        <React.Fragment>
            <section className="section bg-light">
                <Container>
                    <Row className="justify-content-center">
                        <div className="section-title text-center">
                            <h3 className="title mb-4 pb-2">
                                Ready to Take the Next Step?
                            </h3>
                            <p>Let’s get started!</p>
                            <p className="para-desc text-muted mx-auto">
                                You can submit your resume now—or if you need a hand, use our quick and easy Resume
                                Builder to create a standout resume directly on our website. Whether you&#39;re polishing up or
                                starting fresh, we’ve got you covered.
                            </p>
                            <p className="text-muted">
                                We can’t wait to help you find a role that excites you, challenges you, and fits your life.
                            </p>
                            <div className="mt-4">
                                <Link to="/resume-builder" className="btn btn-primary btn-hover mt-2">
                                    <i className="uil uil-rocket me-1"></i> Build Your Resume
                                </Link>
                                {/* <Link
                                    to="/contact-us"
                                    className="btn btn-outline-primary btn-hover ms-sm-1 mt-2"
                                >
                                    <i className="uil uil-capsule me-1"></i> Free Trial
                                </Link> */}
                            </div>
                        </div>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};

export default Cta;
